if (!customElements.get('subscribe-and-save-selector')) {
  customElements.define('subscribe-and-save-selector', class SubscribeAndSaveSelector extends HTMLElement {
    constructor() {
      super();
      this.purchaseTypeRadios = this.querySelectorAll('input[name^="purchase_type"]');
      this.planRadios = this.querySelectorAll('input[name^="selling_plan"]');
      this.plansContainer = this.querySelector('[data-plans-container]');
      this.productForm = null;

      this.init();
    }

    init() {
      // Find the product form - look for the closest form first, then fallback to any form
      this.productForm = this.closest('form.product-form') || document.querySelector('form.product-form[data-section-id]');

      if (!this.productForm) {
        console.error('Subscribe and Save: Product form not found');
        return;
      }

      // Add event listeners
      this.purchaseTypeRadios.forEach(radio => {
        radio.addEventListener('change', this.handlePurchaseTypeChange.bind(this));
      });

      this.planRadios.forEach(radio => {
        radio.addEventListener('change', this.handlePlanChange.bind(this));
      });

      // Initialize expanded state based on default selection
      const checkedPurchaseType = this.querySelector('input[name^="purchase_type"]:checked');
      if (checkedPurchaseType && checkedPurchaseType.value === 'subscription') {
        const plansTitle = this.querySelector('.subscribe-and-save__plans-title');
        if (plansTitle) {
          plansTitle.classList.add('expanded');
        }
      }

      // Initialize with default selection
      this.updateSellingPlan();
    }

    handlePurchaseTypeChange(event) {
      const isSubscription = event.target.value === 'subscription';

      // Toggle plans container visibility with accordion
      if (this.plansContainer) {
        if (isSubscription) {
          this.plansContainer.classList.add('expanded');
        } else {
          this.plansContainer.classList.remove('expanded');
        }
      }

      // Toggle benefits list visibility with accordion
      const benefitsList = this.querySelector('.subscribe-and-save__benefits');
      if (benefitsList) {
        if (isSubscription) {
          benefitsList.classList.add('expanded');
        } else {
          benefitsList.classList.remove('expanded');
        }
      }

      // Toggle plans title visibility with accordion
      const plansTitle = this.querySelector('.subscribe-and-save__plans-title');
      if (plansTitle) {
        if (isSubscription) {
          plansTitle.classList.add('expanded');
        } else {
          plansTitle.classList.remove('expanded');
        }
      }

      this.updateSellingPlan();
    }

    handlePlanChange() {
      this.updateSellingPlan();
    }

    updateSellingPlan() {
      // Find the checked purchase type
      const checkedPurchaseType = this.querySelector('input[name^="purchase_type"]:checked');

      if (!checkedPurchaseType) return;

      // Get all product forms on the page (main form and sticky footer form)
      const allProductForms = document.querySelectorAll('form.product-form[data-section-id]');

      // Update all forms with the selling plan selection
      allProductForms.forEach(form => {
        // Remove any existing selling_plan input from this form
        const existingInput = form.querySelector('input[name="selling_plan"]');
        if (existingInput) {
          existingInput.remove();
        }

        // If subscription is selected, add the selling plan input to this form
        if (checkedPurchaseType.value === 'subscription') {
          const selectedPlan = this.querySelector('input[name^="selling_plan"]:checked');

          if (selectedPlan) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'selling_plan';
            input.value = selectedPlan.value;
            form.appendChild(input);
          }
        }
      });

      // Dispatch custom event for other scripts that might need to know
      if (checkedPurchaseType.value === 'subscription') {
        const selectedPlan = this.querySelector('input[name^="selling_plan"]:checked');
        if (selectedPlan) {
          this.dispatchEvent(new CustomEvent('selling-plan-changed', {
            detail: {
              sellingPlanId: selectedPlan.value,
              purchaseType: 'subscription',
              price: selectedPlan.dataset.price,
              compareAtPrice: selectedPlan.dataset.compareAtPrice
            },
            bubbles: true
          }));
        }
      } else {
        // Dispatch event for one-time purchase
        const onetimeRadio = this.querySelector('input[name^="purchase_type"][value="onetime"]');
        this.dispatchEvent(new CustomEvent('selling-plan-changed', {
          detail: {
            sellingPlanId: null,
            purchaseType: 'onetime',
            price: onetimeRadio ? onetimeRadio.dataset.price : null
          },
          bubbles: true
        }));
      }
    }

    // Public method to get current selection
    getSelection() {
      const checkedPurchaseType = this.querySelector('input[name^="purchase_type"]:checked');
      const selectedPlan = this.querySelector('input[name^="selling_plan"]:checked');

      return {
        purchaseType: checkedPurchaseType ? checkedPurchaseType.value : null,
        sellingPlanId: selectedPlan ? selectedPlan.value : null
      };
    }
  });
}

// Listen for selling plan changes and update button price
document.addEventListener('selling-plan-changed', function(event) {
  // Get the formatted price from the event detail
  const formattedPrice = event.detail.price;
  const compareAtPrice = event.detail.compareAtPrice;

  if (!formattedPrice) return;

  // Update the Subscribe & Save pricing display
  const pricingContainer = document.querySelector('.subscribe-and-save__pricing');

  if (pricingContainer && event.detail.purchaseType === 'subscription') {
    const currentPriceElement = pricingContainer.querySelector('.subscribe-and-save__current-price');
    const comparePriceElement = pricingContainer.querySelector('.subscribe-and-save__compare-price');

    if (currentPriceElement) {
      currentPriceElement.textContent = `${formattedPrice}/unit`;
    }

    if (compareAtPrice && comparePriceElement) {
      comparePriceElement.textContent = compareAtPrice;
      comparePriceElement.style.display = 'block';
    } else if (comparePriceElement) {
      comparePriceElement.style.display = 'none';
    }
  }

  // Find the add to cart button and update its price
  const addToCartButton = document.querySelector('button[name="add"]');
  if (!addToCartButton) return;

  const buttonTextSpan = addToCartButton.querySelector('span');
  if (!buttonTextSpan) return;

  // Get the "Add to cart" text (or current text before the dash)
  const currentText = buttonTextSpan.textContent;
  const addToCartText = currentText.split(' - ')[0];

  // Update the button text with new price
  buttonTextSpan.textContent = `${addToCartText} - ${formattedPrice}`;
});
